import React from "react";

function WhyMeditation() {
  return (
    <div className="">
      <div className="color-title">
        <span>Why Meditation?</span>
      </div>
      <div>
        <iframe
          className="video-responsive"
          src="https://www.youtube.com/embed/j-rlT3-CSnY"
          allowFullScreen
          allow=""
        ></iframe>
      </div>
    </div>
  );
}

export default WhyMeditation;
